import React from "react";
import { useNavigate } from "react-router-dom";
import { experience, essay } from "../data/site";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

const Work = () => {
  const exp = experience;
  const e = essay;
  const navigate = useNavigate();

  const goToEssay = (ev: React.MouseEvent) => {
    ev.preventDefault();
    const site = document.querySelector(".site");
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!site || reduce) { navigate("/essay"); return; }
    site.classList.remove("fx-in");
    site.classList.add("fx-out");
    setTimeout(() => navigate("/essay"), 300);
  };

  return (
    <section className="section work" id="work">
      <SectionHead
        num="02"
        kicker="Work"
        title={exp.title}
        sub={exp.subTitle}
      />
      <ol className="timeline">
        {exp.items.map((item, i) => (
          <Reveal key={i} delay={i * 80}>
            <li className="tl-item">
              <div className="tl-period">{item.period}</div>
              <div className="tl-node" />
              <div className="tl-body">
                <h3 className="tl-role">{item.role}</h3>
                <div className="tl-org">{item.org}</div>
                <p className="tl-note">{item.note}</p>
              </div>
            </li>
          </Reveal>
        ))}
      </ol>

      <a className="essay-feature" href="/essay" onClick={goToEssay}>
        <div className="ef-meta">
          <span className="ef-kicker">{e.kicker}</span>
          <span className="ef-read">{e.readTime}</span>
        </div>
        <h3 className="ef-title">{e.title}</h3>
        <p className="ef-blurb">{e.cardBlurb}</p>
        <span className="ef-cta">
          Read the essay <span className="ef-arrow">→</span>
        </span>
      </a>
    </section>
  );
};

export default Work;
